import { Button, Field, ModalDrawer, RadioGroup, useModalState } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { FC, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

// Compononent to Be used within a FormProvider from react-hook-form
export const EditBrokerDealer: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { openModal, closeModal, isOpen } = useModalState()
  const [defaultBrokerDealerField, setDefaultBrokerDealerField] = useState<boolean | undefined>(undefined)

  const { control, watch, setValue } = useFormContext()

  const brokerDealerField = watch('isBrokerDealer')

  useEffect(() => {
    if (brokerDealerField !== undefined && defaultBrokerDealerField === undefined) {
      setDefaultBrokerDealerField(brokerDealerField)
    }
  }, [brokerDealerField])

  // Closes the modal and reverts the value to the default value
  // Only using the closeModal method will persist the value
  const closeWithoutSaving = () => {
    setValue('isBrokerDealer', defaultBrokerDealerField)
    closeModal()
  }

  const closeWithSaving = () => {
    setDefaultBrokerDealerField(brokerDealerField)
    closeModal()
  }

  return (
    <>
      <Field
        className="border-b py-sm"
        valueClassName="text-text-meta typo-primary-base-regular"
        value={t('edit_fields.broker_dealer_title')}
        rightValue={brokerDealerField ? t('common.yes') : t('common.no')}
        testId={'editIsBrokerDealer'}
        onEdit={openModal}
      />
      <ModalDrawer isOpen={isOpen} onClose={closeWithoutSaving} title={t('edit_fields.edit_broker_dealer')}>
        <>
          <p className="typo-primary-base-regular text-text-body mb-sm">{t('edit_fields.broker_dealer_description')}</p>
          <Controller
            name="isBrokerDealer"
            control={control}
            rules={{
              required: true,
              validate: (value: unknown) => (typeof value === 'number' && !isNaN(value)) || 'Field is required',
            }}
            render={({ field: { ref, ...restField } }) => (
              <RadioGroup
                {...restField}
                value={restField.value ? 1 : 0}
                options={[
                  { value: 0, label: t('common.no') },
                  { value: 1, label: t('common.yes') },
                ]}
                name="isBrokerDealer"
                testId="is-broker-dealer-radio"
              />
            )}
          />
          {brokerDealerField ? (
            <p className="typo-primary-base-regular text-text-body">{t('edit_fields.is_yes_broker_dealer')}</p>
          ) : null}
          <Button size="small" onClick={closeWithSaving} className="w-full mt-lg" testId="primaryAction_button">
            {t('common.confirm')}
          </Button>
        </>
      </ModalDrawer>
    </>
  )
}
